import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=20d1c17a&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=js"
export * from "./Bill.vue?vue&type=script&lang=js"
import style0 from "./Bill.vue?vue&type=style&index=0&id=20d1c17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d1c17a",
  null
  
)

export default component.exports